
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gR84W", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8a6HB = parcelRequire("8a6HB");


var $caX7N = parcelRequire("caX7N");


var $lqsSp = parcelRequire("lqsSp");


var $fFa3V = parcelRequire("fFa3V");


var $gaT0F = parcelRequire("gaT0F");


var $iYyyX = parcelRequire("iYyyX");


var $5zdke = parcelRequire("5zdke");

const $2da3d51e2f5cb9f8$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $2da3d51e2f5cb9f8$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $gaT0F.default), nudge: Nudge = (0, $8a6HB.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $42omo.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $42omo.useRef)(null);
    const spotlightCardRef = (0, $42omo.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $42omo.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $42omo.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $42omo.useState)(false);
    const stopBlink = (0, $42omo.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $42omo.useRef)({
        fn: ()=>{}
    });
    (0, $42omo.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $42omo.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $42omo.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $42omo.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $42omo.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $42omo.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $42omo.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $42omo.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $fFa3V.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $2da3d51e2f5cb9f8$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.(event);
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $42omo.useMemo)(()=>Spotlight === (0, $gaT0F.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iYyyX.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5zdke.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $l998X.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $2da3d51e2f5cb9f8$export$2e2bcd8739ae039 = $2da3d51e2f5cb9f8$export$eebbda33f5d4d735;
module.exports["NudgeSpotlight"] = $2da3d51e2f5cb9f8$export$eebbda33f5d4d735;

});

parcelRegister("8a6HB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dH6p2 = parcelRequire("dH6p2");

const $29992d3b9988a368$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dH6p2.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));
module.exports["DefaultNudge"] = $29992d3b9988a368$export$b7d614104f4a4a7c;

});

parcelRegister("dH6p2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $dh538 = parcelRequire("dh538");

function $ad7aee5d47af256f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad7aee5d47af256f$var$baseShadow = '0 0 0 3px';
const $ad7aee5d47af256f$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $6fnsQ).P75})`;
const $ad7aee5d47af256f$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $ad7aee5d47af256f$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $ad7aee5d47af256f$var$pulseAnimation = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $ad7aee5d47af256f$var$easing,
    animationIterationCount: 'infinite'
});
const $ad7aee5d47af256f$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $ad7aee5d47af256f$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $9K4OG.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $ad7aee5d47af256f$var$pulseAnimation
            ]
        }
    });
const $ad7aee5d47af256f$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = 3, pulseColor: pulseColor = $ad7aee5d47af256f$var$basePulseColor, pulseShadowColor: pulseShadowColor = $ad7aee5d47af256f$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $9K4OG.jsx)(CastTargetContainer, {
        css: [
            $ad7aee5d47af256f$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $dh538.fg)('jira_onboarding_experiences_a11y_fixes') && $ad7aee5d47af256f$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $ad7aee5d47af256f$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};
module.exports["NudgeTooltipPulse"] = $ad7aee5d47af256f$export$2d11151259bb3b10;

});

parcelRegister("gaT0F", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");


var $9K4OG = parcelRequire("9K4OG");

function $a7e0fadb3f4108bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a7e0fadb3f4108bd$var$borderRadius = 3;
const $a7e0fadb3f4108bd$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $6fnsQ.N50A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $6fnsQ.P300)})`,
    borderRadius: `${$a7e0fadb3f4108bd$var$borderRadius}px`,
    overflow: 'auto'
};
const $a7e0fadb3f4108bd$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $a7e0fadb3f4108bd$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $a7e0fadb3f4108bd$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $a7e0fadb3f4108bd$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $a7e0fadb3f4108bd$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $9K4OG.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $6fnsQ.P300})` : `var(--ds-background-inverse-subtle, ${0, $6fnsQ.P400})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $6fnsQ.P200)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $6fnsQ.P200)})`
        }
    });
const $a7e0fadb3f4108bd$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        css: $a7e0fadb3f4108bd$var$actionItemStyles(index),
        ...rest
    });
const $a7e0fadb3f4108bd$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $a7e0fadb3f4108bd$export$b3ae98194e057550 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $42omo.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)($a7e0fadb3f4108bd$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$a7e0fadb3f4108bd$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$headerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $a7e0fadb3f4108bd$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $9K4OG.jsx)("span", null), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: $a7e0fadb3f4108bd$var$actionItemContainerStyles
    }, renderedActions))));
});
var $a7e0fadb3f4108bd$export$2e2bcd8739ae039 = $a7e0fadb3f4108bd$export$b3ae98194e057550;
module.exports["default"] = $a7e0fadb3f4108bd$export$2e2bcd8739ae039;

});

parcelRegister("iYyyX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7uLCZ = parcelRequire("7uLCZ");


var $caX7N = parcelRequire("caX7N");

const $32f6e4307bc25262$export$474e8ee88cc7cd8f = 200;
const $32f6e4307bc25262$export$3d6f334bf7dc4597 = 120;
const $32f6e4307bc25262$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$32f6e4307bc25262$export$474e8ee88cc7cd8f}ms`
};
const $32f6e4307bc25262$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$32f6e4307bc25262$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $32f6e4307bc25262$var$timeoutDurations = {
    enter: 0,
    exit: $32f6e4307bc25262$export$3d6f334bf7dc4597
};
const $32f6e4307bc25262$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7uLCZ.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $32f6e4307bc25262$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$32f6e4307bc25262$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$32f6e4307bc25262$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));
module.exports["SpotlightContainer"] = $32f6e4307bc25262$export$d0f55839b708c0a0;

});


//# sourceMappingURL=OnboardingNudgeTooltip.1d606217.js.map
